import serviceImage1 from '../assets/images/service_thumbnail_img_1.jpg';
import serviceImage2 from '../assets/images/service_thumbnail_img_2.jpg';
import serviceImage3 from '../assets/images/service_thumbnail_img_3.jpg';
import serviceImage4 from '../assets/images/service_thumbnail_img_4.jpg';
import serviceImage5 from '../assets/images/service_thumbnail_img_5.jpg';
import serviceImage6 from '../assets/images/service_thumbnail_img_6.jpg';
import serviceImage7 from '../assets/images/service_thumbnail_img_7.jpg';
import serviceImage8 from '../assets/images/service_thumbnail_img_8.jpg';


export const ServicesData = [
    {
        index: '1',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                viewBox="0 0 61.285 63.929"
                className="svg replaced-svg"
            >
                <path
                    className="cls-1"
                    style={{ fill: 'rgb(40,40,40)' }}
                    d="M1630.5,1278.15c-.155-5.381-3.739-9.573-5.261-11.118a9.37,9.37,0,1,0-17.135-7.574,8.642,8.642,0,0,0-2.313.244l.707,2.915a5.62,5.62,0,0,1,6.515,3.254l2.759-1.179a8.6,8.6,0,0,0-4.652-4.59,6.362,6.362,0,0,1,11.692,4.919,10.885,10.885,0,0,0-1.1-.723l-1.422,2.642a22.478,22.478,0,0,1,2.321,1.724c.163.145,4.749,4.289,4.891,9.591.08,2.957-1.254,5.8-3.965,8.444l-.6.583.181.816c.013.06,1.314,6.1-1.407,9.721a6.77,6.77,0,0,1-4.552,2.566,9.473,9.473,0,0,0-2.312-4.807,8.243,8.243,0,0,0,1.4-5.1l-2.992.219a5.678,5.678,0,0,1-2.393,4.811,6,6,0,0,1-3.991,1.241l-.217,2.992q.3.023.6.022a9.046,9.046,0,0,0,5.411-1.857c.044-.033.081-.072.125-.106a6.52,6.52,0,0,1,.59,7.495,6.442,6.442,0,0,1-11.989-3.143v-10.58a2.012,2.012,0,0,1,1.131-1.444,2.719,2.719,0,0,1,1.748-.1,2.039,2.039,0,0,1,1.3.735l2.641-1.425a4.856,4.856,0,0,0-3.269-2.234,5.713,5.713,0,0,0-3.551.26v-3.981a15.012,15.012,0,0,0,2.013.137,12.312,12.312,0,0,0,6.172-1.54,9.813,9.813,0,0,0,5.267,1.669,7.767,7.767,0,0,0,5.883-2.749l-2.217-2.021a5.1,5.1,0,0,1-6.492,1.052,9.713,9.713,0,0,0,1.1-1.589l-2.625-1.451c-2.292,4.148-7.209,3.769-9.1,3.449v-9.929c1.688,1.118,3.983,2.354,5.894,2.354v-3c-1.533,0-4.263-1.76-5.894-3.057v-9.568a6.6,6.6,0,0,1,6.565-6.625,7.071,7.071,0,0,1,4.311,1.635l1.947-2.283a9.962,9.962,0,0,0-6.257-2.352,9.544,9.544,0,0,0-8.017,4.391,5.684,5.684,0,0,0-.826-.938,9.615,9.615,0,1,0-14.369,12.765,5.747,5.747,0,0,0,1.375,10.625l.717-2.913a2.75,2.75,0,1,1,1.312-5.342l.009-.036a9.561,9.561,0,0,0,3.58.7v-3a6.625,6.625,0,1,1,6.248-8.808,2.719,2.719,0,0,1-.566,1.941,2.755,2.755,0,0,1-3.864.46l-1.854,2.36a5.753,5.753,0,0,0,6.689.3v12.932a5.986,5.986,0,0,0-2.068-.267,5.859,5.859,0,0,0-4.06,1.942l-.144.192a41.211,41.211,0,0,1-4.629,5.957,29.146,29.146,0,0,0-6.738-4.613l-1.277,2.715a26.461,26.461,0,0,1,5.824,3.954,5.943,5.943,0,0,1-3.27,1.6v3c5.348,0,11.555-9.341,12.553-10.9a2.854,2.854,0,0,1,3.809-.248v15.4c0,.005,0,.01,0,.016h0v4.529a4.547,4.547,0,0,0-5.6,2.105l2.639,1.425a1.584,1.584,0,0,1,2.136-.64,1.588,1.588,0,0,1,.821,1.458h.007v1.528h-.014a6.5,6.5,0,1,1-11.286-4.552l4.543-4.944-2.209-2.029-2.244,2.442-3.7-1.3-1,2.831,2.483.873-.092.1a9.445,9.445,0,0,0-2.346,4.844,6.767,6.767,0,0,1-4.517-2.552c-2.713-3.605-1.426-9.672-1.413-9.73l.181-.816-.6-.583c-2.711-2.646-4.045-5.487-3.966-8.444.145-5.37,4.857-9.561,4.9-9.6l.694-.6-.223-.892c-1-4.017-.347-6.673,1.952-7.892l-1.4-2.651c-2.42,1.284-4.953,4.128-3.654,10.412-1.524,1.546-5.109,5.742-5.264,11.122-.1,3.613,1.343,7.016,4.3,10.123-.315,2.065-.793,7.51,2.084,11.347a9.879,9.879,0,0,0,6.9,3.789,9.446,9.446,0,0,0,7.072,7.757,9.585,9.585,0,0,0,2.315.286,9.469,9.469,0,0,0,7.965-4.377,9.223,9.223,0,0,0,3.057,3.016,9.434,9.434,0,0,0,4.873,1.361,9.576,9.576,0,0,0,2.314-.286,9.44,9.44,0,0,0,7.072-7.754,9.887,9.887,0,0,0,6.931-3.792c2.877-3.837,2.4-9.282,2.084-11.347C1629.155,1285.166,1630.6,1281.763,1630.5,1278.15Zm-6.862-10.692-.02.023.019-.023Z"
                    transform="translate(-1569.219 -1247.523)"
                ></path>
            </svg>
        ),
        title: 'Strategy',
    },
    {
        index: '2',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                viewBox="0 0 61.69 61.664"
                className="svg replaced-svg"
            >
                <path
                    className="cls-1"
                    style={{ fill: 'rgb(30,30,30)' }}
                    d="M1611.818,1223.483l-.033-1.434-1.434-.037a61.1,61.1,0,0,0-23.906,4.959l-1.119.5,2.382,10.773,2.93-.648-1.85-8.364a58.392,58.392,0,0,1,17.752-4.092l-56.409,56.411,2.121,2.121,10.251-10.251a11.616,11.616,0,0,0,6.808,1.916c5.842,0,13.38-2.971,21.049-8.605l2.636-1.936-17.775-4.094,2.432-2.432,16.78,3.821.666-2.924-14.94-3.4,2.487-2.487,16.751,3.816.666-2.924-14.911-3.4,2.662-2.663,16.734,3.73.541-.988C1612.019,1238.2,1611.829,1224.078,1611.818,1223.483Zm-25.989,42.739c-8.687,5.662-16.843,7.594-21.157,5.028l8.047-8.048Zm17.155-17.808-12.657-2.821,18.326-18.326A57.865,57.865,0,0,1,1602.984,1248.414Z"
                    transform="translate(-1550.131 -1222.006)"
                ></path>
                <path
                    className="cls-1"
                    d="M1561.645,1266.643c-1.366-7.272,4.651-19.324,14.633-29.307a33.891,33.891,0,0,1,3.832-3.283l2.291,9.53,2.917-.7-3.3-13.722-1.78,1.156a37.635,37.635,0,0,0-6.082,4.9c-10.81,10.811-17.023,23.663-15.46,31.982Z"
                    transform="translate(-1550.131 -1222.006)"
                    style={{ fill: 'rgb(30, 30, 30)' }}
                ></path>
            </svg>
        ),
        title: 'Print Design',
    },
    {
        index: '3',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                viewBox="0 0 72.824 55.465"
                className="svg replaced-svg"
            >
                <title>Art-Direction2</title>
                <path
                    className="cls-1"
                    style={{ fill: 'rgb(61,61,61)' }}
                    d="M1609.855,1246.889c0-.04,0-.082,0-.126.274-6.909-1.4-12.3-4.969-16.012s-8.849-5.576-15.727-5.576H1578.83v11.989a6.471,6.471,0,1,0,0,12.245v9.626h0v18.606h-11.268v-7.732h-12.939a.949.949,0,0,1-.947-.948v-11.093h-4.938l5.075-10.3v-.349c0-.133-.007-.326-.017-.575-.09-2.26-.362-9.136,4.135-13.813,2.97-3.09,7.534-4.656,13.565-4.656h4.02v-3h-4.02c-6.879,0-12.171,1.876-15.728,5.576-3.571,3.716-5.243,9.1-4.97,16.012q0,.066.006.126l-6.889,13.978h6.761v8.093a3.952,3.952,0,0,0,3.947,3.948h9.939v7.732h17.268V1265.5a6.474,6.474,0,1,0,0-12.251l0-10.307h0v-14.767h7.334c6.031,0,10.594,1.566,13.564,4.655,4.5,4.678,4.224,11.554,4.134,13.814-.009.249-.016.442-.016.575v.349l5.075,10.3h-4.939v11.093a.96.96,0,0,1-.947.948H1593.1v7.732h-7.778v3H1596.1v-7.732h9.939a3.952,3.952,0,0,0,3.947-3.948v-8.093h6.761Zm-33.13-.131a3.475,3.475,0,1,1,0-6.949,3.43,3.43,0,0,1,2.515,1.085l2.263,2.393-2.26,2.384A3.438,3.438,0,0,1,1576.725,1246.758Zm9.672,10.159a3.475,3.475,0,0,1,0,4.913,3.55,3.55,0,0,1-4.975-.069l-2.266-2.387,2.266-2.388A3.549,3.549,0,0,1,1586.4,1256.917Z"
                    transform="translate(-1543.919 -1225.175)"
                ></path>
            </svg>
        ),
        title: 'Art Direction',
    },
    {
        index: '4',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                viewBox="0 0 58.682 66.002"
                className="svg replaced-svg"
            >
                <title>Admin-Systems2</title>
                <path
                    className="cls-1"
                    d="M1553.847,1252.555a30.012,30.012,0,0,1,51.23-21.216l2.121-2.122a33.006,33.006,0,1,0-23.347,56.338v-3A30.036,30.036,0,0,1,1553.847,1252.555Z"
                    transform="translate(-1550.847 -1219.553)"
                    style={{ fill: 'rgb(21, 21, 21)' }}
                ></path>
                <path
                    className="cls-1"
                    d="M1583.851,1226.355a26.2,26.2,0,1,0,0,52.4v-3a23.2,23.2,0,1,1,22.738-27.867l2.939-.6A26.3,26.3,0,0,0,1583.851,1226.355Z"
                    transform="translate(-1550.847 -1219.553)"
                    style={{ fill: 'rgb(21, 21, 21)' }}
                ></path>
                <path
                    className="cls-1"
                    d="M1567.453,1252.555a16.415,16.415,0,0,1,16.4-16.4v-3a19.395,19.395,0,1,0,0,38.789v-3A16.414,16.414,0,0,1,1567.453,1252.555Z"
                    transform="translate(-1550.847 -1219.553)"
                    style={{ fill: 'rgb(21, 21, 21)' }}
                ></path>
                <path
                    className="cls-1"
                    d="M1583.851,1239.962a12.592,12.592,0,1,0,0,25.184v-3a9.592,9.592,0,1,1,9.2-12.356l2.872-.867A12.691,12.691,0,0,0,1583.851,1239.962Z"
                    transform="translate(-1550.847 -1219.553)"
                    style={{ fill: 'rgb(21, 21, 21)' }}
                ></path>
            </svg>
        ),
        title: 'Admin Systems',
    },
    {
        index: '5',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                viewBox="0 0 59.354 59.34"
                className="svg replaced-svg"
            >
                <title>Brand-Identities2</title>
                <path
                    className="cls-1"
                    d="M1580.349,1222.587a29.67,29.67,0,1,0,29.682,29.671A29.7,29.7,0,0,0,1580.349,1222.587Zm16.835,9c-5.692-1.617-14.44-3.192-22.241-.791l.882,2.867c10.6-3.258,23.395,1.608,25.883,2.631a26.643,26.643,0,0,1,3.274,5.725c-5.084-2.118-15-5.059-26.191-2.08l.772,2.9c12.67-3.374,23.6,1.476,26.7,3.073a26.6,26.6,0,0,1,.77,6.35c0,.106-.007.21-.008.316-3.95-1.9-13.572-5.392-26.547-2.445-8.579-9.979-9.443-20.094-9.511-22.833a26.625,26.625,0,0,1,26.219,4.288Zm-15.594,21.374a41.268,41.268,0,0,1,8.341-.943c-.858,4.1-4.4,16.271-17.37,25.731l.017.023a26.556,26.556,0,0,1-5.868-2.6C1577.167,1268.433,1580.9,1255.667,1581.59,1252.958Zm-27.913-.7a26.692,26.692,0,0,1,14.338-23.637c.293,4.292,1.952,14.149,10.579,23.919a43.778,43.778,0,0,1-2.807,7.313,35.859,35.859,0,0,1-12.182-20.646l-2.939.6a38.785,38.785,0,0,0,13.683,22.735,34.432,34.432,0,0,1-3.822,5.333c-4.773-2.729-8.511-7.641-11.093-14.661l-2.815,1.035c2.715,7.384,6.664,12.7,11.745,15.853a24.3,24.3,0,0,1-4.383,3.19A26.63,26.63,0,0,1,1553.677,1252.258Zm22.653,26.366a46.588,46.588,0,0,0,16.638-26.522,38.142,38.142,0,0,1,6.424.99c-1.09,4.639-5.388,19.784-16.1,25.616l.027.05a26.507,26.507,0,0,1-6.985-.134Zm14.266-1.746c7.454-7.494,10.686-18.74,11.684-22.956a28.877,28.877,0,0,1,4.505,1.907A26.738,26.738,0,0,1,1590.6,1276.878Z"
                    transform="translate(-1550.677 -1222.587)"
                    style={{ fill: 'rgb(4, 4, 4)' }}
                ></path>
            </svg>
        ),
        title: 'Brand Identities',
    },
    {
        index: '6',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                viewBox="0 0 65.191 48.36"
                className="svg replaced-svg"
            >
                <title>UI-UX-Design2</title>
                <path
                    className="cls-1"
                    d="M1108.435,1284.107h3v-7.925h-3Zm7.172,0h3v-15.244h-3Zm21.52,0h3v-16.53h-3Zm-14.346,0h3v-29.619h-3Zm7.174,0h3v-22.369h-3Zm-35.4-18.326h-3v4.432h3Zm51.711-21.965H1090.07a4.505,4.505,0,0,0-4.5,4.5v39.361a4.505,4.505,0,0,0,4.5,4.5h56.192a4.505,4.505,0,0,0,4.5-4.5v-39.361A4.505,4.505,0,0,0,1146.262,1243.816Zm-48.918,45.361h-7.274a1.5,1.5,0,0,1-1.5-1.5v-39.361a1.5,1.5,0,0,1,1.5-1.5h7.274Zm50.418-1.5a1.5,1.5,0,0,1-1.5,1.5h-45.918v-42.361h45.918a1.5,1.5,0,0,1,1.5,1.5Z"
                    transform="translate(-1085.57 -1243.816)"
                    style={{ fill: 'rgb(3, 3, 3)' }}
                ></path>
            </svg>
        ),
        title: 'UI/UX Design',
    },
    {
        index: '7',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                viewBox="0 0 50.814 64.883"
                className="svg replaced-svg"
            >
                <title>Backend2</title>
                <path
                    className="cls-1"
                    d="M1560.9,1230.386a12.882,12.882,0,0,1-2.482-4.918,14.162,14.162,0,0,0,8.068,2.312h27.891a14.148,14.148,0,0,0,8.067-2.312,12.953,12.953,0,0,1-2.6,5.062l2.3,1.931a15.253,15.253,0,0,0,3.584-10.92,1.5,1.5,0,0,0-2.773-.653c-.1.159-2.5,3.892-8.575,3.892h-27.891c-6.071,0-8.476-3.733-8.569-3.882a1.5,1.5,0,0,0-2.778.643,15.2,15.2,0,0,0,3.442,10.748Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
                <path
                    className="cls-1"
                    d="M1604.9,1250.455l-.1-.323a1.5,1.5,0,0,0-2.057-.927c-.335.152-8.222,3.88-9.275,16.235l2.99.255c.627-7.362,3.933-11.1,5.953-12.719,1.371,6.894.174,15.823-11.056,22.686a5.4,5.4,0,0,0-4.492-2.507,5.662,5.662,0,0,0-5.432,4.938h-2a5.661,5.661,0,0,0-5.432-4.938,5.4,5.4,0,0,0-4.492,2.507c-11.252-6.876-12.432-15.826-11.059-22.688,2.023,1.624,5.33,5.359,5.957,12.721l2.989-.255c-1.053-12.355-8.94-16.083-9.275-16.235a1.5,1.5,0,0,0-2.057.927l-.112.372c-1.8,6.706-2.5,19.17,12.557,28.048-.016.183-.027.368-.027.555a5.754,5.754,0,0,0,5.519,5.951,5.57,5.57,0,0,0,5.2-3.965h2.468a5.568,5.568,0,0,0,5.2,3.965,5.754,5.754,0,0,0,5.519-5.951c0-.187-.01-.372-.026-.555C1607.409,1269.674,1606.709,1257.21,1604.9,1250.455Zm-30.894,31.6a2.989,2.989,0,1,1,2.519-2.951A2.764,2.764,0,0,1,1574,1282.058Zm12.859,0a2.989,2.989,0,1,1,2.519-2.951A2.764,2.764,0,0,1,1586.861,1282.058Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
                <path
                    className="cls-1"
                    d="M1601.942,1240.741a9.908,9.908,0,1,0-19.816,0,9.82,9.82,0,0,0,.15,1.654,9.068,9.068,0,0,0-3.7.072,9.933,9.933,0,1,0-4.452,6.632l5.09,6.681a1.6,1.6,0,0,0,1.241.591,1.5,1.5,0,0,0,1.193-.591l5.091-6.681a9.89,9.89,0,0,0,15.2-8.358Zm-9.908-6.908a6.907,6.907,0,1,1-6.908,6.908A6.916,6.916,0,0,1,1592.034,1233.833Zm-30.114,6.908a6.908,6.908,0,1,1,6.908,6.906A6.916,6.916,0,0,1,1561.92,1240.741Zm18.511,11.686-4.039-5.3a9.74,9.74,0,0,0,.66-.866c.788-.473,3.9-2.074,6.772.021a9.825,9.825,0,0,0,.646.845Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
                <path
                    className="cls-1"
                    d="M1592.035,1243.02a2.28,2.28,0,1,0-2.279-2.278A2.281,2.281,0,0,0,1592.035,1243.02Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
                <path
                    className="cls-1"
                    d="M1568.829,1238.462a2.28,2.28,0,1,0,2.278,2.28A2.282,2.282,0,0,0,1568.829,1238.462Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
                <path
                    className="cls-1"
                    d="M1572.818,1259.417a2.279,2.279,0,1,0,2.279,2.279A2.282,2.282,0,0,0,1572.818,1259.417Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
                <path
                    className="cls-1"
                    d="M1582.711,1261.7a2.28,2.28,0,1,0-2.279,2.279A2.282,2.282,0,0,0,1582.711,1261.7Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
                <path
                    className="cls-1"
                    d="M1590.324,1261.7a2.279,2.279,0,1,0-2.278,2.279A2.281,2.281,0,0,0,1590.324,1261.7Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
                <path
                    className="cls-1"
                    d="M1576.625,1270.311a2.28,2.28,0,1,0-2.279-2.279A2.281,2.281,0,0,0,1576.625,1270.311Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
                <path
                    className="cls-1"
                    d="M1584.238,1270.311a2.28,2.28,0,1,0-2.279-2.279A2.282,2.282,0,0,0,1584.238,1270.311Z"
                    transform="translate(-1555.022 -1220.174)"
                ></path>
            </svg>
        ),
        title: 'Back End',
    },
    {
        index: '8',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                viewBox="0 0 54.49 67.197"
                className="svg replaced-svg"
            >
                <title>Frontend2</title>
                <path
                    className="cls-1"
                    d="M1560.292,1271.086a27.245,27.245,0,0,1,18.916-45.636v-6.391l19.381,11.215-19.381,11.205v-6.339a17.569,17.569,0,0,0-10.523,30.649l-2,2.239a20.569,20.569,0,0,1,13.682-35.926h1.838v4.177l10.389-6.006-10.389-6.012v4.165h-1.838a24.245,24.245,0,0,0-17.868,40.632Z"
                    transform="translate(-1553.126 -1219.059)"
                    style={{ fill: 'rgb(21, 21, 21)' }}
                ></path>
                <path
                    className="cls-1"
                    d="M1581.532,1286.256l-19.381-11.218,19.381-11.2v6.364a17.568,17.568,0,0,0,10.5-30.668l1.992-2.243a20.567,20.567,0,0,1-13.654,35.949h-1.838v-4.2l-10.388,6,10.388,6.013v-4.137h1.838a24.245,24.245,0,0,0,17.943-40.551l2.219-2.019a27.245,27.245,0,0,1-19,45.546Z"
                    transform="translate(-1553.126 -1219.059)"
                    style={{ fill: 'rgb(21, 21, 21)' }}
                ></path>
            </svg>
        ),
        title: 'Front End',
    },
];

export const ServicesImageData = [
    {
        index: '1',
        image: {
            src: serviceImage1,
            alt: 'Prevention Services',
        },
        heading: 'Prevention',
        paragraph: (
            <ul>
                <li>Community based advocacy</li>
                <li>Family based</li>
                <li>Media based</li>
                <li>School based</li>
            </ul>
        ),
    },
    {
        index: '2',
        image: {
            src: serviceImage2,
            alt: 'Treatment Services',
        },
        heading: 'Treatment',
        paragraph: (
            <ul>
                <li>Rehabilitation & Recovery support</li>
                <li>Mental health counseling</li>
                <li>Behavioral therapy intervention</li>
            </ul>
        ),
    },
    {
        index: '3',
        image: {
            src: serviceImage4,
            alt: 'Recovery Services',
        },
        heading: 'Recovery',
        paragraph: (
            <ul>
                <li>&nbsp;</li>
            </ul>
        ),
    },
];
